
import { useQueryClient } from "@tanstack/react-query";
import BaseContentForm, { ContentFormProps } from "./BaseContentForm";

const AddContentForm = ({ onComplete }: ContentFormProps) => {
  const queryClient = useQueryClient();
  
  const handleComplete = async () => {
    console.log("AddContentForm: Handling completion");
    
    // Invalidate the query to refresh the content
    queryClient.invalidateQueries({ queryKey: ['contentItems'] });
    
    // Call the onComplete callback if provided
    if (onComplete && typeof onComplete === 'function') {
      onComplete();
    }
  };
  
  return <BaseContentForm onComplete={handleComplete} />;
};

export default AddContentForm;
